import {combineReducers} from 'redux';
import {createAction, handleActions} from 'redux-actions';
import axios from 'axios';
import WageReducer from '../../stores/CarDamage/WageReducer';
import PartReducer from '../../stores/CarDamage/PartReducer';
import PartItemReducer from '../../stores/CarDamage/PartItemReducer';
import CarReducer from '../../stores/CarDamage/CarReducer';
import StockReducer from '../../stores/CarDamage/StockReducer';
import DamageReducer from '../../stores/CarDamage/DamageReducer';
import FixLevelReducer from '../../stores/CarDamage/FixLevelReducer'
import LoadingReducer from '../../stores/CarDamage/LoadingReducer';
const reduceReducers = (...reducers) => (previous, current) =>
    reducers.reduce((p, r) => r(p, current), previous);

const {damabeTableView} = JSON.parse(localStorage.getItem('kkc_workdoc') ||
                          '{}') || {};

const initialState = {
  view: damabeTableView || 1,
  wo: '',
  carID: '',
  carSize: '',
  carType: '',
  partID: 0,
};

// export const loadPartList = (action = {}) => (dispatch, getState) => {
//   const state = getState();
//
//   axios.get(`/damage/part_item/3/work?format=json`).
//       then((response) => {
//         dispatch(setPartList(response.data));
//       }).
//       catch((error) => {
//         console.error(error);
//       });
// };
// export const setPartList = createAction('SET_PART_LIST');
//
// export const partListReducer = (defaultState) => handleActions({
//   loadPartList,
//
//   [setPartList](state, action) {
//     const {payload} = action;
//     return {
//       ...state,
//       partList: payload && payload.data && payload.data.list || [],
//     };
//   },
// }, defaultState);

export default reduceReducers(...[
  combineReducers({
    car: CarReducer(initialState),
    partItem: PartItemReducer([]),
    partList: PartReducer([]),
    wageList: WageReducer([]),
    stockList: StockReducer([]),
    damageList: DamageReducer([]),
    fixlevel: FixLevelReducer([]),
    loading : LoadingReducer({
      partGroup: false,
      partItem: false,
      wage: false,
      stock: false,
      damage: false,
    })
  }),
]);



// WEBPACK FOOTER //
// ./src/view/workdoc/CarDamageActions.js